var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('no-ssr',[(_vm.hasSlides)?_c('SfCarousel',{staticClass:"m-product-carousel",attrs:{"settings":{
      type: 'slider',
      animationDuration: 250,
      rewindDuration: 500,
      rewind: true,
      perView: 4,
      peek: {
        before: 0,
        after: 50,
      },
      slidePerPage: false,
      breakpoints: {
        767: {
          perView: 1,
        },
        991: {
          perView: 2,
        },
        1200: {
          perView: 3,
        },
      }
    }}},[(_vm.showAd)?_c('SfCarouselItem',[_c('div',{staticClass:"card-category card-category-ad"},[_c('div',{staticClass:"card-category-ad__title"},[_vm._v("\n          Fußleiste & Dämmung inkl.\n        ")]),_vm._v(" "),_c('div',{staticClass:"card-category-ad__description"},[_vm._v("\n          Entspricht mindestens der bestellten Fläche (m²) des Bodenbelags.\n        ")]),_vm._v(" "),_c('div',{staticClass:"card-category-ad_icon all-in"},[_c('img',{attrs:{"src":"/assets/custom/icons/icon-all-in-white.svg","width":"auto","height":"70px"}})])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.categoriesCarouselFiltered),function(category,i){return _c('SfCarouselItem',{key:i},[_c('router-link',{staticClass:"card-category",attrs:{"to":category.url_path}},[_c('div',{staticClass:"card-category__image"},[(category.image)?_c('SfImage',{attrs:{"src":_vm.getThumbnailPath(category.image)}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"card-category__name"},[_vm._v("\n          "+_vm._s(category.name)+"\n        ")])])],1)})],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }